var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirplaneSearch = function SvgAirplaneSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 7.875 9.007 5.25 9 3.375C9.007.75 6.75 0 6.75 0S4.493.75 4.493 3.375V5.25L0 7.875v2.25L5.046 8.87l.204 2.755L3 13.5l.75 1.5 3-1.125 3 1.125.75-1.5-2.25-1.875.204-2.755 5.046 1.255z"
  })));
};
export default SvgAirplaneSearch;